import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from '@app/services/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'drivers',
    loadChildren: () => import('./drivers/drivers.module').then((m) => m.DriversModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('./analytics/analytics.module').then((m) => m.AnalyticsModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'qualification-files',
    loadChildren: () =>
      import('./qualification-files/qualification-files.module').then(
        (m) => m.QualificationFilesModule
      ),
    canActivate: [AuthGuard],
    data: {
      requiredPermissions: [
        {
          permissionType: 'READ',
          resourceName: 'Qualification Files',
        },
        {
          permissionType: 'WRITE',
          resourceName: 'Qualification Files',
        },
      ],
    },
  },
  {
    path: 'intervention',
    loadChildren: () =>
      import('./intervention/intervention.module').then((m) => m.InterventionModule),
    canActivate: [AuthGuard],
    data: {
      requiredPermissions: [
        {
          permissionType: 'READ',
          resourceName: 'All Interventions',
        },
        {
          permissionType: 'WRITE',
          resourceName: 'All Interventions',
        },
        {
          permissionType: 'WRITE',
          resourceName: 'My Interventions',
        },
      ],
    },
  },
  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then((m) => m.EventsModule),
    canActivate: [AuthGuard],
    data: {
      requiredPermissions: [
        {
          permissionType: 'READ',
          resourceName: 'Events',
        },
        {
          permissionType: 'WRITE',
          resourceName: 'Events',
        },
      ],
    },
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'test',
    loadChildren: () => import('./test/test.module').then((m) => m.TestModule),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Don't perform initial navigation in iframes or popups
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? 'enabledNonBlocking'
          : 'disabled', // Set to enabledBlocking to use Angular Universal
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
